<template>
  <div class="container productDetail" :style="posterShow ? {'overflow': 'hidden'} : {}" v-wechat-title="title">
    <follow @follow="followFn"></follow>
    <header :class="{'ceiling': ceil}" :style="[zIndex ? {'z-index': '-1'} : {}, follow ? {'top': '0.5rem'} : {'top': '0'}]">
      <ul>
        <li @click="navClick(index)" :class="{'colorLis': navId==index}" v-for="(item, index) in nav" :key="index">{{ item }}</li>
      </ul>
    </header>
    <div id="cup">
      <div class="maininfo d_jump" id="Glide">
        <div ref="ifscroll" class="swiper-container" id="pro_pic" style="height: auto;">
          <div class="swiper_height" v-show="(productDateils.video_play_url != '') && playShow">
            <div class="swiper-slide" style="background: #333;height: 100%;">
              <div style="width: 100%;height: 100%;" v-if="productDateils.video_img_url!=null && productDateils.video_img_url!=''">
                <img :src="productDateils.video_img_url" @load="loadvideo"
                     style="display:none;"/>
                <div class="zy_media" style="width: 100%;height: 100% !important;">
                  <video id="banner_video" style="width: 100%;height: 100%;" :poster="productDateils.video_img_url" data-config="创客村"  webkit-playsinline="true" playsinline="true" x5-playsinline="true" x-webkit-airplay="allow" preload="true">
                    <source :src="productDateils.video_play_url" type="video/mp4">
                    <source :src="productDateils.video_play_url" type="video/m3u8">
                    您的浏览器不支持HTML5视频
                  </video>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-wrapper swiper_height" v-show="imgShow">
            <div class="swiper-slide" v-for="(item,index) in bannerList" :key="index"><img v-lazy="item" @click="preview(item, index, 'banner')"/></div>
          </div>
          <div id="proSwiperPagination" v-show="imgShow" class="swiper-pagination swiper-pagination-fraction"
               v-if="bannerList && bannerList.length > 0">
            <div class="pro_page">
              {{activeIndex+1}} / {{bannerList.length}}
            </div>
          </div>
          <div class="playTab" v-if="productDateils.video_play_url != ''">
            <span @click="playTab(0)" :style="playShow ? {background: 'linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%)', border: '0.01rem solid transparent', color: '#FFFFFF'} : {}">
              <van-icon :color="playShow ? '#ffffff' : '#353535'" size="0.11rem" :name="icon" /><b>视频</b></span>
            <span @click="playTab(1)" :style="imgShow ? {background: 'linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%)', border: '0.01rem solid transparent', color: '#FFFFFF'} : {}"><b>图片</b></span>
          </div>
        </div>
        <van-skeleton
          title
          :row="3"
          :loading="loading"
        >
          <div class="pro_price">
            <div class="xian">
              <span class="smallprice" v-if="productDateils.sales_bottom_price">
                <sub>¥</sub>
                <b>{{productDateils.sales_bottom_price ? String(parseFloat(productDateils.sales_bottom_price).toFixed(2)).slice(0, String(parseFloat(productDateils.sales_bottom_price).toFixed(2)).indexOf('.')) : '0'}}</b>
                <sup>{{productDateils.sales_bottom_price ? String(parseFloat(productDateils.sales_bottom_price).toFixed(2)).slice(String(parseFloat(productDateils.sales_bottom_price).toFixed(2)).indexOf('.'), String(parseFloat(productDateils.sales_bottom_price).toFixed(2)).length) : '.00'}}</sup>
              </span>
              <span v-if="productDateils.sales_bottom_price && parseFloat(productDateils.sales_bottom_price) != parseFloat(productDateils.sales_top_price)">-</span>
              <span class="bigprice" v-if="parseFloat(productDateils.sales_bottom_price) != parseFloat(productDateils.sales_top_price)">
                <b>{{productDateils.sales_top_price ? String(parseFloat(productDateils.sales_top_price).toFixed(2)).slice(0, String(parseFloat(productDateils.sales_top_price).toFixed(2)).indexOf('.')) : '0'}}</b>
                <sup>{{productDateils.sales_top_price ? String(parseFloat(productDateils.sales_top_price).toFixed(2)).slice(String(parseFloat(productDateils.sales_top_price).toFixed(2)).indexOf('.'), String(parseFloat(productDateils.sales_top_price).toFixed(2)).length) : '.00'}}</sup>
              </span>
            </div>
            <div class="yuan">
              <span class="smallprice" v-if="productDateils.cost_bottom_price">
                ¥{{productDateils.cost_bottom_price ? parseFloat(productDateils.cost_bottom_price).toFixed(2) : '0'}}
              </span>
              <span v-if="productDateils.cost_bottom_price && parseFloat(productDateils.cost_bottom_price) != parseFloat(productDateils.cost_top_price)">-</span>
              <span class="bigprice" v-if="parseFloat(productDateils.cost_bottom_price) != parseFloat(productDateils.cost_top_price)">
                {{productDateils.cost_top_price ? parseFloat(productDateils.cost_top_price).toFixed(2) : '.00'}}
              </span>
            </div>
          </div>
          <div class="pro_tit">
            <van-tag color="#FEE9E6"  v-if="actopen.is_pre_item == 1" text-color="#F12A0E" style="font-size: 0.1rem;padding: 0.01rem 0.03rem 0.01rem;position:relative; top: -0.008rem">预售</van-tag>
          {{productDateils.name}}<img v-if="productDateils.property === 'overseas'" src="../../assets/images/overseas.png" class="overseas"/>
        </div>
        </van-skeleton>
      </div>
      <div class="pro_comment d_jump" style="border-top: 0">
        <div class="pro_comment_tit" v-if="">
          {{productEvaluate.list && productEvaluate.list.length > 0 ? '产品评价（'+productEvaluate.comment_nums+'）' : '暂无评价'}}
          <div class="pro_comment_more" @click="goCommentList" v-if="productEvaluate.list && productEvaluate.list.length > 0">
            <div class="hp">好评{{productEvaluate.comment_rate}}</div> <van-icon name="arrow"></van-icon>
          </div>
        </div>
        <div class="tags" v-if="tagslist && tagslist.length && productEvaluate.list && productEvaluate.list.length">
          <ul>
            <li v-if="item" v-for="(item, index) of tagslist" :key="index">{{item}}</li>
          </ul>
        </div>
        <div v-if="productEvaluate.list && productEvaluate.list.length > 0" class="pro_comment_list">
          <div class="pro_comment_item" v-for="(item, index) of productEvaluate.list" :key="index">
            <div class="comment_head_info" @click="commentDetail(item)">
              <div class="sj">
                <van-rate v-model="item.itemscore" :size="15" void-color="#eeeeee" void-icon="star" color="#FFCD07" readonly />
              </div>
              <div class="img">
                <img v-if="item.head" :src="item.head" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}"/>
                <img v-if="!item.head" :src="errorHeadImg"/>
              </div>
              <div class="info">
                <div class="name">
                  {{item.smallname}}
                </div>
                <div class="time">{{item.time}} 规格：{{item.spec}}</div>
              </div>
            </div>
            <div class="comment_content_info">
              <div class="comment_txt" @click="commentDetail(item)">
                {{item.content}}
              </div>
              <div class="comment_pic">
                <div class="swiper-container">
                  <swiper :options="swiperOption" ref="mySwiper">
                    <swiper-slide v-if="item.path1"><img v-lazy="item.path1" @click="preview(item, 0, 'comment')"/></swiper-slide>
                    <swiper-slide v-if="item.path2"><img v-lazy="item.path2" @click="preview(item, 1, 'comment')"/></swiper-slide>
                    <swiper-slide v-if="item.path3"><img v-lazy="item.path3" @click="preview(item, 2, 'comment')"/></swiper-slide>
                    <swiper-slide v-if="item.path4"><img v-lazy="item.path4" @click="preview(item, 3, 'comment')"/></swiper-slide>
                    <swiper-slide v-if="item.path5"><img v-lazy="item.path5" @click="preview(item, 4, 'comment')"/></swiper-slide>
                    <swiper-slide v-if="item.path6"><img v-lazy="item.path6" @click="preview(item, 5, 'comment')"/></swiper-slide>
                  </swiper>
                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>
            <div class="comment_oper">
              <div class="button" @click="commentLike(item)"><img :src="item.islike == 0 ? require('../../assets/images/zan.png') : require('../../assets/images/zan1.png')"/>{{parseInt(item.like_nums) > 0 ? item.like_nums : '点赞' }}</div>
              <div class="button" @click="commentDetail(item)"><img src="../../assets/images/ly.png"/>{{parseInt(item.leave_nums) > 0 ? item.leave_nums : '留言' }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="pro_arg">
        <van-skeleton
          title
          :row="3"
          :loading="loading"
        >
          <div class="pro_arg_tit">产品信息</div>
          <div class="pro_arg_list">
            <div class="pro_mess" v-if="!isshow">
              <div class="pro_arg_item" v-if="productDateils.brand">
                <span>【产品品牌】</span>
                <span>{{productDateils.brand}}</span>
              </div>
              <div class="pro_arg_item" v-if="specification">
                <span>【产品规格】</span>
                <span>{{specification}}</span>
              </div>
            </div>
            <div class="pro_mess" v-if="isshow">
              <div class="pro_arg_item" v-if="productDateils.brand">
                <span>【产品品牌】</span>
                <span>{{productDateils.brand}}</span>
              </div>
              <div class="pro_arg_item" v-if="specification">
                <span>【产品规格】</span>
                <span>{{specification}}</span>
              </div>
              <div class="pro_arg_item" v-if="productDateils.usescope">
                <span>【适用范围】</span>
                <span>{{productDateils.usescope}}</span>
              </div>
              <div class="pro_arg_item" v-if="productDateils.item_character">
                <span>【商品特性】</span>
                <span>{{productDateils.item_character}}</span>
              </div>
              <div class="pro_arg_item" v-if="productDateils.usemethod">
                <span>【使用方法】</span>
                <span>{{productDateils.usemethod}}</span>
              </div>
              <div class="pro_arg_item" v-if="productDateils.useyear">
                <span>【使用年限】</span>
                <span>{{productDateils.useyear}}</span>
              </div>
            </div>
            <div class="pro_arg_more" @click="stretch">
              {{isshow===false?'展开':'收起'}}
              <van-icon name="arrow-down" v-if="isshow===false"/>
              <van-icon name="arrow-up" v-else/>
            </div>

          </div>
        </van-skeleton>
      </div>
      <div class="pro_details d_jump">
        <div class="pro_details_tit">
          商品详情
        </div>
        <div class="pro_details_con" v-html="productDateils.description">
        </div>
      </div>
      <div class="d_jump">
      <div class="pro_related_goods" v-if="productlist && productlist.length > 0">
        <div class="pro_related_goods_tit">
          <van-divider :style="{ color: '#222222', borderColor: '#DBDBDB', padding: '0.14rem 0 0.05rem', margin: '0', fontSize:'.14rem' }">
            相关推荐
          </van-divider>
        </div>
        <div style="margin:0 0.11rem 0;" class="productbanner">
          <div v-for="item of productBannerList" @click="productBannerFn(item)">
            <img style="width: 100%" v-lazy="item.img_path"/>
          </div>
        </div>
        <div class="pro_related_list" style="padding-top: 0.1rem">
          <product-item v-for="(item, index) of productlist" @itemid="itemId" :prolistItem="item" :key="index"></product-item>
        </div>
      </div>
    </div>
    </div>
    <div class="homeBtn" @click="homeClick">
      <img src="/static/images/homebtn.png">
    </div>
    <van-marquee v-if="zcIndex > 0" :itemid="$route.query.itemid"></van-marquee>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import Swiper from 'swiper/dist/js/swiper.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import '../../assets/css/zy.media.css'
import { Rate, Divider, Overlay, Sku, Loading, ImagePreview, Tag, Skeleton } from 'vant'
import productItem from '../../components/common/productItem'
import follow from '../common/follow'
import vanMarquee from '../common/vanMarquee'
import { customRequestAjax } from '@/axiosApi'
import zymedia from '../../assets/js/zy.media'
import { isWeixin, kefu, fenxiang, Base64, appid } from '../../assets/common/js/config'
import actCoupon from '../common/coupon'
import Vue from 'vue'
Vue.use(VueAwesomeSwiper /* { default global options } */)
Vue.use(ImagePreview)
Vue.config.ignoredElements = ['wx-open-launch-weapp']
export default {
  name: 'productDetail',
  components: {
    [Rate.name]: Rate,
    [Divider.name]: Divider,
    [Overlay.name]: Overlay,
    [Sku.name]: Sku,
    [Loading.name]: Loading,
    [Tag.name]: Tag,
    [Skeleton.name]: Skeleton,
    productItem,
    follow,
    actCoupon,
    vanMarquee
  },
  data () {
    var that = this
    return {
      icon: 'play',
      follow: null,
      recCount: 0,
      communityid: this.$route.query.communityid ? this.$route.query.communityid : '',
      loading: true,
      sureGray: true,
      showaction: false,
      msglist: [],
      showPresale: false,
      presaledescpt: '',
      actopen: {},
      isShare: false,
      posterShow: false,
      playShow: false,
      imgShow: false,
      posterList: [],
      posterUrlBase: '',
      posterUrl: [],
      qrcode: '',
      posterIndex: 0,
      // loadingShow: false,
      postImgData: '',
      posterDataLoading: false,
      title: '',
      posterSwiperOption: {
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true
      },
      showsku: false,
      showshare: false,
      activeIndex: 0,
      bannerSwiper: null,
      galleryThumbs: null,
      islove: false,
      isshow: false,
      isoverseas: false, // 判断该商品是不是海外商品
      value: 5,
      propic: null,
      bannerList: [],
      show: false,
      skuname: '',
      skuprice: '197.00-218.90',
      specification: '',
      ceil: false,
      zIndex: false,
      wuIndex: 0,
      daiIndex: 0,
      zcIndex: 0,
      navId: 0,
      skuId: null, // 总规格id 注： 传给后端的参数
      itemnum: null, // 购买数量 注：传给后端的参数
      buyType: null, // 判断点击‘加入购物袋’或‘立即购买’，0加入购物袋  1立即购买,
      productlist: [],
      productBannerList: [],
      skuValueToast: null,
      nav: ['商品', '评论', '详情', '推荐'],
      productEvaluate: {},
      quota: 0,
      quotaUsed: 0,
      sku: {
        tree: [],
        list: [],
        price: '1.00',
        stock_num: 0
        // collection_id: 2261,
        // none_sku: false,
        // hide_stock: false
      },
      goods: {
        title: '',
        picture: ''
      },
      initialSku: {},
      i: 0,
      customStepperConfig: {
        quotaText: '每次限购xxx件',
        handleOverLimit: (data) => {
          // console.log(data)
          const { action, limitType, quota, quotaUsed } = data;

          if (action === 'minus') {
            this.$toast('至少选择一件商品');
          } else if (action === 'plus') {
            // const { LIMIT_TYPE } = Sku.skuConstants;
            // if (limitType === LIMIT_TYPE.QUOTA_LIMIT) {
            // let msg = `单次限购${quota}件`;
            // if (quotaUsed > 0) msg += `，你已购买${quotaUsed}`;
            let msg = `数量超出范围~`
            this.$toast(msg);
            // } else {
            //   Toast('库存不够了');
            // }
          }
        },
        handleStepperChange: currentValue => {},
        stockNum: 0,
        stockFormatter: stockNum => {}
      },
      productDateils: {},
      tagslist: [],
      swiperOption: {
        slidesPerView: 3.3,
        spaceBetween: 7,
        observer: true,
        observeParents: true
      },
      discountrule: {},
      productInfo: null,
      live_ad_url: null, // 直播链接
      live_cover_img: null, // 直播小窗图
    }
  },
  mounted: function () {
    let that = this
    if (isWeixin()) {
      that.isShare = true
    }

    window.scrollTo(0, 0)
    that.getData()
    that.$nextTick(function () {
      that.bannerSwiper = new Swiper('#pro_pic', {
        autoplay: false,
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionStart: function () {
            that.activeIndex = this.activeIndex
          }
        }
      })
      that.propic = new Swiper('.comment_pic .swiper-container', {
        slidesPerView: 3.3,
        spaceBetween: 7,
        observer: true,
        observeParents: true
      })
      window.addEventListener('scroll', that.scrollWatch)
      var videoBar = $('#Glide .swiper-slide')
      var video = videoBar.find('video')
      let isiOS = !!navigator.userAgent.match(
        /\(i[^;]+;( U;)? CPU.+Mac OS X/
      );
      if (!isiOS) {
        setTimeout(() => {
          let videoContexts = document.querySelectorAll(
            ".zy_media video"
          );
          videoContexts.forEach(videoContext => {
            let imgElement = document.createElement("img");
            imgElement.style.display = "block";
            imgElement.style.width = "100%";
            imgElement.src = that.productDateils.video_img_url;
            videoContext.parentNode.style.display = "block";
            videoContext.parentNode.append(imgElement);
            videoContext.addEventListener("play", () => {
              imgElement.style.display = "none";
              videoContext.style.display = "block";
              videoContext.parentNode.style.display = "block";
              that.bannerSwiper.autoplay.stop()
            })
            videoContext.addEventListener("pause", () => {
              imgElement.style.display = "block";
              videoContext.style.display = "none";
              // videoContext.parentNode.style.display = "none";
              that.bannerSwiper.autoplay.start()
            })
          })
        }, 500)
      } else {
        video.on('play', function () {
          that.bannerSwiper.autoplay.stop()
        })
        video.on('pause', function () {
          that.bannerSwiper.autoplay.start()
        })
      }
    })
    // // 挂载完成后，判断浏览器是否支持popstate
    // if (window.history && window.history.pushState) {
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener('popstate', this.goBack, false)
    // }
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.scrollWatch)
    this.$toast.clear()
    this.$dialog.close()
    sessionStorage.removeItem('choose_coupon')
    sessionStorage.removeItem('choose_product')
  },
  beforeRouteEnter (to, from, next) {
    next()
  },
  computed: {
    currentdiscount () {
      var that = this
      let currentdiscount = 1
      if (that.discountrule && that.discountrule.discountenable == 1) {
        let discountlist = that.discountrule.discountlist
        try {
          discountlist.forEach(function (item, index) {
            if (parseInt(that.itemnum) >= parseInt(item.itemnum)) {
              let discount1 = item.discount
              currentdiscount = discount1
              throw new Error()
            }
          })
        } catch (e) {
          return currentdiscount
        }
      }
      return currentdiscount
    }
  },
  methods: {
    getData: function () {
      var base = new Base64()
      var that = this
      var index = -1
      var item, getItemInfo
      var isinvalid = false
      var url
      if (this.$route.query.live_id) {
        url = 'Wxmall/Item/getItemInfo?itemid=' + this.$route.query.itemid + '&liveid=' + this.$route.query.live_id
      } else {
        url = 'Wxmall/Item/getItemInfo?itemid=' + this.$route.query.itemid
      }
      that.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      customRequestAjax(url).then(res => {
        isinvalid = true
        that.$toast.clear()
        that.$dialog.close()
        if (res.data.code === 200) {
          if(res.data.is_invalid == 1) {// 无效
            that.$dialog.alert({
              message: '商品过期不存在，请您去首页转转',
              className: 'percen_button_alert integral_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '去首页',
              closeOnPopstate: false
            }).then(function () {
              // on confirm
              that.$router.replace('/')
            })
          } else {
            that.productInfo = res.data
            f(res.data)
            g(res.data)
          }
        }
      }).catch(err => {
        setTimeout(function () {
          if (!isinvalid) {
            that.$toast.clear()
            that.$dialog.close()
            that.$dialog.alert({
              // title: '积分使用规则',
              message: '商品过期不存在，请您去首页转转',
              className: 'percen_button_alert integral_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '去首页',
              closeOnPopstate: false
            }).then(function () {
              // on confirm
              that.$router.replace('/')
            })
          }
        }, 3000)
      })
      function f (data) {
        if (data.iteminfo.video_img_url != '' || data.iteminfo.video_play_url != '') {
          that.playShow = true
          that.imgShow = false
        } else {
          that.playShow = false
          that.imgShow = true
        }
        if (data.iteminfo.iscollection === '0') {
          that.islove = false
        } else {
          that.islove = true
        }
        that.goods.title = data.iteminfo.name
        that.goods.picture = data.iteminfo.img_path
        if (data.iteminfo && data.iteminfo.sku_rule_list.length <= 1) {
          that.skuname = data.iteminfo.sku_rule_list[0].sku_name
        }
        if (data.iteminfo && parseFloat(data.iteminfo.sales_bottom_price) != parseFloat(data.iteminfo.sales_top_price)) {
          that.skuprice = parseFloat(data.iteminfo.sales_bottom_price).toFixed(2) + '-' + parseFloat(data.iteminfo.sales_top_price).toFixed(2)
        } else {
          that.skuprice = parseFloat(data.iteminfo.sales_bottom_price).toFixed(2)
        }
        that.bannerList = data.iteminfo.img_paths
        that.productDateils = data.iteminfo
        if (that.productDateils.poster && that.productDateils.poster.length <= 0) {
          that.productDateils.poster.push({posterurl: that.productDateils.img_main_path})
        }
        that.specification = ''
        var len = that.productDateils.normlist
        for (var i = 0; i < len.length; i++) {
          if (len[i].spec_classify_name === '规格') {
            for (var j = 0; j < len[i].speclist.length; j++) {
              that.specification += len[i].speclist[j].spec_name + ' '
            }
            break
          }
        }
        that.sku.tree = []
        that.productDateils.normlist.map(function (item, index) {
          that.sku.tree.push({
            k: item.spec_classify_name,
            v: [],
            k_s: 's' + (index + 1)
          })
          item.speclist.map(function (itemSon) {
            that.sku.tree[index].v.push({
              id: itemSon.spec_id,
              name: itemSon.spec_name
            })
          })
        })
        that.wuIndex = 0
        that.daiIndex = 0
        that.zcIndex = 0
        if (that.productDateils.islimit == 1) {
          that.wuIndex = 0
          that.daiIndex = 1
          that.zcIndex = 0
        } else if (that.productDateils.islimit == 2) {
          that.wuIndex = 1
          that.daiIndex = 0
          that.zcIndex = 0
        } else {
          that.productDateils.sku_rule_list.map(function (item) {
            if ((item.issale == 0 || item.canbuycnt <= 0) && item.is_can_buy == 0) {
              that.wuIndex++
            } else if (item.issale == 1 && item.canbuycnt > 0) {
              if (item.islimit == 2 && item.is_can_buy == 0) { // 已售罄
                that.wuIndex++
              } else if (item.islimit == 1) { // 待售
                that.daiIndex++
              } else if (item.islimit == 0) {
                that.zcIndex++
              }
            }
          })
        }
        console.log('zcIndex', that.zcIndex)
        that.live_cover_img = data.live_cover_img
        that.live_ad_url = data.live_ad_url
        if (data.isdiscount) {
          that.actopen.isdiscount = data.isdiscount
        }

        if (data.isfullgift) {
          that.actopen.isfullgift = data.isfullgift
        }

        if (data.ispresale) {
          that.actopen.ispresale = data.ispresale
        }
        if (data.is_pre_item) {
          that.actopen.is_pre_item = data.is_pre_item
        }
        if (data.is_pre_item) {
          that.actopen.is_pre_item = data.is_pre_item
        }
        if (data.is_ck_community_item) {
          that.actopen.is_ck_community_item = data.is_ck_community_item
        }
        that.discountrule = data.discountrule
        that.msglist = []
        if (data.discountrule && data.discountrule.discountenable == 1 && data.discountrule.discountlist && data.isdiscount == 1) {
          var msg = []
          data.discountrule.discountlist.forEach(function (item, index) {
            var txt = ((item.discount) * 100) % 10 == 0 ? (((item.discount) * 100) / 10) : (item.discount) * 100
            msg.push(item.itemnum + '件' + txt + '折')
          })
          var discountruledesc = '满' + msg.join(',')
          that.msglist.push({
            enable: data.discountrule.discountenable,
            shortdesc: discountruledesc,
            desc: data.discountrule.discountdesc,
            name: data.discountrule.name,
            actlabel: data.discountrule.actlabel
          })
        }

        if (data.halfpricestatus == 1) {
          that.msglist.push({
            enable: data.halfpricestatus,
            shortdesc: data.halfactname,
            desc: data.halfactdesc,
            name: data.halfactlabel,
            actlabel: data.halfactlabel
          })
        }

        if (data.fullgiftrule && data.fullgiftrule.actstatus == 1 && data.fullgiftrule.rulelist && data.isfullgift == 1) {
          that.msglist.push({
            enable: data.fullgiftrule.actstatus,
            shortdesc: data.fullgiftrule.actname,
            desc: data.fullgiftrule.actdesc,
            name: data.fullgiftrule.actlabel,
            actlabel: data.fullgiftrule.actlabel
          })
        }
        if (data.presaledescpt) {
          that.presaledescpt = data.presaledescpt
        }
        that.loading = false
      }
      function g (data) {
        that.title = that.$route.meta.title = data.iteminfo.name
        if (that.$route.query.itemid) {
          var usescope = data.iteminfo.usescope
          var img = data.iteminfo.img_main_path
          if (usescope != '' && usescope != null && usescope != undefined) {
            fenxiang({
              title: encodeURIComponent(that.title),
              desc: encodeURIComponent(usescope),
              imgx: img,
              type: 'detail',
              dataStr: 'type=detail&params=' + base.encode(JSON.stringify({itemid: that.$route.query.itemid, shareOpenid: appid, productName: encodeURI(that.title)})
              ),
              path: 'productdetail'
            })
          } else {
            fenxiang({
              title: encodeURIComponent(that.title),
              desc: encodeURIComponent('好礼已经备好，就差你了'),
              imgx: img,
              type: 'detail',
              dataStr: 'type=detail&params=' + base.encode(JSON.stringify({itemid: that.$route.query.itemid, shareOpenid: appid, productName: encodeURI(that.title)})),
              path: 'productdetail'
            })
          }
        }
        var urlEval = 'Wxmall/Comment/getCommentByItem?item_base_id=' + data.iteminfo.itemid
        customRequestAjax(urlEval).then(res => {
          if (res.data.code === 200) {
            that.productEvaluate = res.data
            that.tagslist = res.data.taglist
            that.productEvaluate.list.map(item => {
              item.itemscore = parseInt(item.itemscore)
            })
          }
        })
      }
    },
    getRecommentDatas: function () {
      var recommentUrl = 'Wxmall/Item/getRecommendByItemInfo?item_base_id=' + this.$route.query.itemid
      var that = this
      customRequestAjax(recommentUrl).then(res => {
        if (res.data.code === 200) {
          that.productlist = res.data.itemlist
          that.productBannerList = res.data.bannerList
          that.productlist.map(item => {
            item.product_detail = 1
          })
        }
      })
    },
    followFn: function (data) {
      this.follow = data
    },
    loadvideo: function () {
      setTimeout(function () {
        zymedia('#banner_video', {aspectRation: ('375' / '375'), 'preload': 'auto', 'hideVideoControlsOnLoad': true})
      })
    },
    itemId: function () {
      let that = this
      that.recCount = 0
      that.loading = true
      that.bannerList = []
      that.getData()
    },
    preview (items, index, type) {
      var imgArr, newImgArr
      if (type == 'comment') {
        imgArr = [items.path1, items.path2, items.path3, items.path4, items.path5, items.path6]
        newImgArr = []
        imgArr.map(item => {
          if (item && item != undefined) {
            newImgArr.push(item)
          }
        })
      } else if (type == 'banner') {
        newImgArr = this.bannerList
      }
      ImagePreview({
        images: newImgArr,
        startPosition: index,
        closeOnPopstate: true
      })
    },
    playTab (num) {
      if (num == 0) {
        if (this.playShow) {
          if (this.icon == 'play') {
            document.querySelectorAll('.zy_media video')[0].play()
            this.icon = 'pause'
          } else {
            document.querySelectorAll('.zy_media video')[0].pause()
            this.icon = 'play'
          }
        }
        this.$nextTick(function () {
          this.playShow = true
          this.imgShow = false
        })
      } else if (num == 1) {
        document.querySelectorAll('.zy_media video')[0].pause()
        this.playShow = false
        this.imgShow = true
      }
    },
    scrollWatch: function () {
      let scrolled = parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop)
      let scrolledHeight = document.documentElement.scrollHeight - scrolled
      let clientHeight = scrolledHeight - document.documentElement.scrollHeight
      if (this.imgShow && clientHeight <= 0) {
        if (this.recCount == 0) {
          this.recCount = 1
          this.getRecommentDatas()
        }
      }
      // 586、1063分别为第二个和第三个锚点对应的距离
      var jump = document.querySelectorAll('.d_jump')
      if (jump[3] && scrolled >= jump[3].offsetTop - 84) {
        this.zIndex = false
        this.ceil = true
        this.navId = 3
      } else if ((jump[3] && scrolled < jump[3].offsetTop - 84) && (jump[2] && scrolled >= jump[2].offsetTop - 84)) {
        if (this.recCount == 0) {
          this.recCount = 1
          this.getRecommentDatas()
        }
        this.zIndex = false
        this.ceil = true
        this.navId = 2
      } else if ((jump[2] && scrolled < jump[2].offsetTop - 84) && (jump[1] && scrolled >= jump[1].offsetTop - 84)) {
        this.zIndex = false
        this.ceil = true
        this.navId = 1
      } else if ((jump[1] && scrolled < jump[1].offsetTop - 84) && (jump[0] && scrolled >= jump[0].clientHeight / 4)) {
        // console.log(4, jump[1].offsetTop, jump[0].clientHeight)
        this.zIndex = false
        this.ceil = true
        this.navId = 0
      } else {
        this.ceil = false
        var that = this
        setTimeout(function () {
          that.zIndex = true
        })
        this.navId = 0
      }
    },
    presell () {
      this.showPresale = false
    },
    close () {
      this.posterShow = false
    },
    stretch () {
      this.isshow = !this.isshow
    },
    goCommentList () {
      this.$router.push({path: '/commentList',
        query: {
          itemid: this.productDateils.itemid
        }
      })
    },
    navClick (id) {
      this.navId = id
      // 用 class="d_jump" 添加锚点
      let jump = document.querySelectorAll('.d_jump')
      let total = jump[id].offsetTop - 84
      let distance = parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop) || parseInt(window.pageYOffset)
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 60
      if (total > distance) {
        smoothDown()
      } else {
        let newTotal = distance - total
        step = newTotal / 60
        smoothUp()
      }
      function smoothDown () {
        if (distance < total) {
          distance += step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          // window.pageYOffset = distance
          setTimeout(smoothDown, 10)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
          // window.pageYOffset = total
        }
      }
      function smoothUp () {
        if (distance > total) {
          distance -= step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          // window.pageYOffset = distance
          setTimeout(smoothUp, 10)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
          // window.pageYOffset = total
        }
      }
    },
    commentDetail (items) {
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$store.commit('PATH_VALUE', JSON.stringify({itemid: this.$route.query.itemid}))
          this.$router.push({
            path: '/login',
            query: {
              routeval: 'productdetail'
            }
          })
        } else {
          this.$router.push({path: '/commentDetail',
            query: {
              commentid: items.id
            }
          })
        }
      } else {
        this.$router.push({path: '/commentDetail',
          query: {
            commentid: items.id
          }
        })
      }
    },
    commentLike (items) {
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$store.commit('PATH_VALUE', JSON.stringify({itemid: this.$route.query.itemid}))
          this.$router.push({
            path: '/login',
            query: {
              routeval: 'productdetail'
            }
          })
        } else {
          f()
        }
      } else {
        f()
      }
      function f () {
        var url = 'Wxmall/Comment/addCommentLike'
        var data = {}
        if (items.islike == 0) {
          data = {
            id: items.id,
            type: 1
          }
        } else if (items.islike == 1) {
          data = {
            id: items.id,
            type: 2
          }
        }
        customRequestAjax.post(url, data).then(res => {
          if (res.data.code === 200) {
            if (items.islike == 0) {
              items.islike = 1
              items.like_nums = parseInt(items.like_nums) + 1
            } else if (items.islike == 1) {
              items.islike = 0
              items.like_nums = parseInt(items.like_nums) - 1
            }
          }
        })
      }
    },
    productBannerFn (items) {
      window.scrollTo(0, 0)
      switch (items.ad_type) {
        case '1': // 跳转链接
          var actid = parseInt(items.activityid) ? '?actid=' + items.activityid : ''
          window.location.href = items.ad_target + actid
          break
        case '2': // 商品分类
          if (items.ad_target == 0) {
            this.$router.push({
              path: '/classification',
              query: {
                type: 'inside'
              }
            })
          } else {
            this.$store.commit('CATEGORY_ID', items.father_class_id)
            this.$store.commit('CATEGORY_SONID', items.ad_target)
            this.$router.push({
              path: '/productCategory',
              title: encodeURIComponent(items.father_class_name)
            })
          }
          break
        case '3':
          this.$router.replace({
            path: 'productdetail',
            query: {
              itemid: items.ad_target
            }
          })
          this.itemId()
          break
        case '4':
          this.$router.push('/')
          break
        case '5':
          this.$router.push('/')
          break

      }
    },
    homeClick: function () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="scss">
  .container {
    background: #fff;
    padding-bottom: .49rem;
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    -moz-flex-direction: column;
    -o-flex-direction: column;
    height: 100%;
    flex: 0;
    -webkit-flex: 0;
    -moz-flex: 0;
    -ms-flex: 0;
    -o-flex: 0;
    header {
      height: 0.4rem;
      background: #fff;
      opacity: 0;
      transition: all .45s;
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      z-index: 10;
      &.ceiling {
        opacity: 1;
      }
      ul {
        display: flex;
        display: -webkit-flex;
        display: -o-flex;
        display: -moz-flex;
        display: -ms-flex;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        -o-justify-content: space-between;
        -moz-justify-content: space-between;
        -ms-justify-content: space-between;
        padding: 0 0.9rem;
        height: 0.37rem;
        li {
          font-size:0.14rem;
          font-weight:400;
          color:rgba(41,41,41,1);
          line-height:0.37rem;
          &.colorLis {
            font-weight: 500;
          }
          &.colorLis:after {
            content: '';
            display: block;
            width: 86%;
            height: 0.025rem;
            background:linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            background: -webkit-linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            background: -moz-linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            background: -ms-linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            background: -o-linear-gradient(90deg,rgba(252,3,36,1),rgba(255,81,104,1));
            position: relative;
            bottom: 0.065rem;
            margin: 0 7%;
            /*border-bottom: 0.02rem solid #FC0324;*/
          }
        }
      }
    }
    #cup {
      flex: 1;
      -webkit-flex: 1;
      -moz-flex: 1;
      -ms-flex: 1;
      -o-flex: 1;
      margin-bottom: 0.47rem;
    }
    .maininfo {
      padding-bottom: .15rem;
      .swiper-container {
        .swiper-wrapper {
          margin: 0;
          padding: 0;
          .swiper-slide {
            padding: 0;
            margin: 0;
            position: relative;
            img {
              width: 100%;
              display: block;
              border: 0;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              -webkit-transform: translateY(-50%);
              -moz-transform: translateY(-50%);
              -ms-transform: translateY(-50%);
              -o-transform: translateY(-50%);
            }
          }
        }
        #proSwiperPagination {
          font-size: .12rem;
          width: .34rem;
          color: #fff;
          position: absolute;
          right: 0.11rem;
          left: auto;
          /*<!--margin-left: -.17rem;-->*/
          bottom: .15rem;
          .pro_page {
            /*position: relative;*/
            background: url(../../assets/images/pagebg.png) no-repeat center;
            background-size: 100% 100%;
            padding: 0 0.0385rem 0.01rem;
            white-space: nowrap;
            .swiper-pagination-current {
              width: .12rem;
              border-radius: .12rem;
              /*position: absolute;*/
              /*top: 0;*/
              /*left: 0;*/
              /*background: #757575;*/
            }
            .swiper-pagination-split {
              margin-left: .02rem;
              margin-right: .02rem;
              /*position: absolute;*/
              /*top: 0;*/
              left: .08rem;
              height: .12rem;
              line-height: .12rem;
              margin-top: .01rem;
              /*background: #757575;*/
              text-align: center;
              font-size: .12rem;
              transform: scale(0.8);
            }
            .swiper-pagination-total {
              width: .12rem;
              border-radius: .12rem;
              /*position: absolute;*/
              /*top: 0;*/
              left: .14rem;
              /*background: #757575;*/
            }
          }

        }
        .playTab {
          /*font-size: 0;*/
          text-align: center;
          position: absolute;
          bottom: 0.15rem;
          z-index: 1;
          left: 0;
          right: 0;
          display: flex;
          display: -webkit-flex;
          display: -moz-flex;
          display: -o-flex;
          display: -ms-flex;
          justify-content: center;
          -webkit-justify-content: center;
          -moz-justify-content: center;
          -o-justify-content: center;
          -ms-justify-content: center;
          span {
            width: 0.47rem;
            height: 0.22rem;
            text-align: center;
            background:rgba(249,249,249,1);
            border-radius:0.11rem;
            border:0.01rem solid rgba(224,225,224,1);
            font-size:0.11rem;
            font-weight:400;
            color:rgba(53,53,53,1);
            display: flex;
            display: -webkit-flex;
            display: -moz-flex;
            display: -o-flex;
            display: -ms-flex;
            align-items: center;
            -webkit-align-items: center;
            -moz-align-items: center;
            -o-align-items: center;
            -ms-align-items: center;
            justify-content: center;
            -webkit-justify-content: center;
            -moz-justify-content: center;
            -o-justify-content: center;
            -ms-justify-content: center;
            b {
              font-weight: 400;
              transform: scale(0.98);
              -webkit-transform: scale(0.98);
              -moz-transform: scale(0.98);
              -ms-transform: scale(0.98);
              -o-transform: scale(0.98);
            }
            &:first-of-type {
              margin-right: 0.045rem;
            }
            &:last-of-type {
              margin-left: 0.045rem;
            }
          }
        }
      }
      .pro_price {
        margin-top: .15rem;
        margin-left: .15rem;
        position: relative;
        .shareCommentPosters {
          position: absolute;
          right: 0.2rem;
          top: 0;
          display: flex;
          display: -webkit-flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -o-flex;
          .comment {
            min-width: 0.36rem;
            img {
              width: .2rem;
              height: .2rem;
              margin: 0 auto;
            }
            p {
              font-size:0.1rem;
              font-weight:400;
              color:rgba(101,101,101,1);
              line-height:0.14rem;
              text-align: center;
              transform: scale(0.8);
              -webkit-transform: scale(0.8);
              -moz-transform: scale(0.8);
              -ms-transform: scale(0.8);
              -o-transform: scale(0.8);
            }
          }
          .posters {
            min-width: 0.36rem;
            img {
              width: .2rem;
              height: .2rem;
              margin: 0 auto;
            }
            p {
              font-size:0.1rem;
              font-weight:400;
              color:rgba(101,101,101,1);
              line-height:0.14rem;
              text-align: center;
              transform: scale(0.8);
              -webkit-transform: scale(0.8);
              -moz-transform: scale(0.8);
              -ms-transform: scale(0.8);
              -o-transform: scale(0.8);
            }
          }
          .share {
            min-width: 0.36rem;
            img {
              width: .2rem;
              height: .2rem;
              margin: 0 auto;
            }
            p {
              font-size:0.1rem;
              font-weight:400;
              color:rgba(101,101,101,1);
              line-height:0.14rem;
              text-align: center;
              transform: scale(0.8);
              -webkit-transform: scale(0.8);
              -moz-transform: scale(0.8);
              -ms-transform: scale(0.8);
              -o-transform: scale(0.8);
            }
          }
        }
        .xian {
          color: #FC0324;
          font-size: .14rem;
          text-align: left;
          .smallprice {
            font-size: 0;
            line-height: .2rem;
          }
          b {
            font-size: .21rem;
            line-height: .2rem;
            font-weight: 500;
          }
          sub {
            font-weight: normal;
            font-size: .12rem;
            vertical-align: baseline
          }
          sup {
            font-size: .11rem;
            vertical-align: baseline;
            font-weight: 500;
          }
          .bigprice {
            font-size: 0;
            line-height: .2rem;
            b {
              font-size: .21rem;
              line-height: .2rem;
              font-weight: 500;
            }
          }
        }
        .yuan {
          color: #6C6C6C;
          text-align: left;
          font-size: .12rem;
          text-decoration: line-through;
          margin-top: -0.05rem;
        }
      }
      .pro_tit {
        font-size: .14rem;
        line-height: .21rem;
        color: #292929;
        text-align: left;
        margin-top: .08rem;
        padding: 0 .15rem;
        font-weight: 650;
        img {
          width: .16rem;
          display: inline-block;
          vertical-align: middle;
          margin-left: .02rem;
        }
      }
    }
    .pro_actinfo {
      border-top: solid .1rem #F5F5F5;
      background: #fff;
      .header {
        overflow: hidden;
        height: .44rem;
        line-height: .44rem;
        position: relative;
        .tag {
          width: .36rem;
          height: .17rem;
          line-height: .17rem;
          display: inline-block;
          text-align: center;
          color: #333333;
          font-size: .14rem;
          border-radius: .07rem;
          margin-left: 2%;
          float: left;
          margin-top: .14rem;
          font-weight: 600;
        }
        .title {
          width: 70%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: inline-block;
          margin-left: .05rem;
          font-size: .12rem;
          float: left;
        }
        img {
          float: right;
          margin-top: .2rem;
          margin-right: .14rem;
          width: .18rem;
        }
        .num {
          font-size: .12rem;
          color: #999;
        }
      }
      .con {
        position: relative;
        padding-left: .1rem;
        padding-right: .14rem;
        padding-bottom: .15rem;
        padding-top: .05rem;
        font-size: .14rem;
        .title {
          width: 100%;
          margin-top: .1rem;
          font-size: .12rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: inline-block;
          margin-left: .05rem;
          color: #383333;
        }
      }
      .header::before {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        top: -50%;
        right: -50%;
        bottom: -50%;
        left: -50%;
        border-bottom: 1px solid #d7d7d7;
        -webkit-transform: scale(.5);
        transform: scale(.5);
      }
      .title-multiple{
        position: absolute;
        top: 0;
        right: 0.11rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .14rem;
      }
    }
    .pro_arg {
      border-top: solid .1rem #F5F5F5;
      background: #fff;
      padding: .2rem .11rem;
      .pro_arg_tit {
        font-size: .14rem;
        line-height: .2rem;
        color: #292929;
        font-weight: 500;
      }
      .pro_arg_list {
        margin-top: .14rem;
        font-size: .13rem;
        line-height: .18rem;
        .pro_arg_item {
          margin-top: .12rem;
          display: flex;
          display: -webkit-flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -o-flex;
          span:nth-child(1) {
            color: #A0A0A0;
            flex-shrink: 0;
            -webkit-flex-shrink: 0;
            -moz-flex-shrink: 0;
            -ms-flex-shrink: 0;
            -o-flex-shrink: 0;
          }
          span:nth-child(2) {
            color: #383333;
          }
        }
        .pro_arg_more {
          text-align: center;
          color: #999999;
          margin-top: .15rem;
          display: flex;
          display: -webkit-flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -o-flex;
          align-items: center;
          -webkit-align-items: center;
          -moz-align-items: center;
          -ms-align-items: center;
          -o-align-items: center;
          justify-content: center;
          -webkit-justify-content: center;
          -moz-justify-content: center;
          -ms-justify-content: center;
          -o-justify-content: center;
          .van-icon {
            margin-left: 0.04rem;
          }
        }
      }
    }
    .pro_comment {
      border-top: solid .1rem #F5F5F5;
      background: #fff;
      padding: .2rem .11rem;
      .tags {
        ul {
          margin-top: -0.05rem;
          margin-bottom: -0.05rem;
          font-size: 0.12rem;
          li {
            width: 30%;
            height: 0.24rem;
            margin-right: 5%;
            line-height: 0.24rem;
            text-align: center;
            color: #292929;
            font-size: 0.12rem;
            border: 0.01rem solid #FCEDEB;
            border-radius: 0.12rem;
            background: #FCEDEB;
            margin-top: 0.1rem;
            white-space: nowrap;
            display: inline-block;
            &:last-of-type {
              margin-right: 0;
            }
          }
        }
      }
      .pro_comment_tit {
        font-size: .14rem;
        color: #292929;
        font-weight: 600;
        position: relative;
        .pro_comment_more {
          position: absolute;
          top: 0;
          right: 0;
          display: flex;
          display: -webkit-flex;
          display: -o-flex;
          display: -ms-flex;
          display: -moz-flex;
          align-items: center;
          -webkit-align-items: center;
          -o-align-items: center;
          -ms-align-items: center;
          -moz-align-items: center;
          .hp {
            color: #FC0324;
            font-size: .13rem;
            float: left;
            font-weight:400;
          }
          .van-icon-arrow {
            float: left;
          }
        }
      }
      .pro_comment_item {
        margin-top: .2rem;
        .comment_head_info {
          position: relative;
          overflow: hidden;
          .sj {
            position: absolute;
            right: 0;
            top: 0;
            z-index: 9;
            font-size: .12rem;
            .van-icon-star {
              font-size: .13rem;
            }
          }
          .img {
            width: .37rem;
            float: left;
            img {
              width: .37rem;
              height: .37rem;
              border-radius: .37rem;
            }
          }
          .info {
            float: left;
            position: relative;
            left: 0.1rem;
            padding-bottom: 0.1rem;
            .name {
              font-size: .14rem;
              line-height: .2rem;
              /*padding-left: .1rem;*/
              width: 2rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              img{
                width: .42rem;
                height: .24rem;
                display: inline-block;
                vertical-align: middle;
                margin-left: -.1rem;
              }
            }

            .time {
              font-size: .1rem;
              /*transform: scale(0.95);*/
              color: #AFB0AF;
              padding-top: 0.03rem;
            }
          }
        }
        .comment_content_info {
          padding-left: .47rem;
          .comment_txt {
            font-size: .14rem;
            line-height: .2rem;
            color: #6D6D6D;
            word-break: break-word;
          }
          .comment_pic {
            margin-top: .1rem;
            .swiper-container {
              width: 100%;
              height: 100%;
              .swiper-slide {
                text-align: center;
                font-size: 18px;
                background: #fff;
                height: .85rem;
                display: -webkit-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                -webkit-box-pack: center;
                -ms-flex-pack: center;
                -webkit-justify-content: center;
                justify-content: center;
                -webkit-box-align: center;
                -ms-flex-align: center;
                -webkit-align-items: center;
                align-items: center;
                img {
                  width: .85rem;
                  border-radius: 0.04rem;
                  overflow: hidden;
                  /*height: .85rem;*/
                }
              }
            }

          }
        }
        .comment_oper {
          overflow: hidden;
          .button {
            /*border: solid 1px #606060;*/
            padding: .04rem .08rem;
            display: inline-block;
            border-radius: .15rem;
            font-size: .11rem;
            color: #6D6D6D;
            float: right;
            margin-left: .15rem;
            margin-top: .1rem;
            img {
              width: .16rem;
              height: .16rem;
              display: block;
              float: left;
              margin-right: .05rem;
            }

          }
        }
      }
    }
    .pro_details {
      border-top: solid .1rem #F5F5F5;
      background: #fff;
      .pro_details_tit {
        font-size: .14rem;
        color: #292929;
        font-weight: 600;
        padding: .2rem .11rem;
        padding-bottom: .1rem;
      }
      .pro_details_con {
        font-size: .14rem;
        img {
          width: 100% !important;
          height: auto !important;
          display: block;
        }
      }
    }
    .pro_related_goods {
      border-top: solid .1rem #F5F5F5;
      background: #fff;
      .pro_related_goods_tit {
        width: 50%;
        margin: 0 auto;
      }
      .pro_related_list {
        padding: 0 .11rem;
        background: #fff;
        overflow: hidden;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        flex-wrap: wrap;
        -moz-flex-wrap: wrap;
        -ms-flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        -o-flex-wrap: wrap;
        .pro_item:nth-child(2n) {
          padding-left: .035rem;
        }
        .pro_item:nth-child(2n-1) {
          padding-right: .035rem;
        }
      }
      .productbanner {
        div {
          border-radius: 0.04rem;
          height: 0.6rem;
          overflow: hidden;
          margin-top: 0.08rem;
          position: relative;
          img {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
          }
          &:first-of-type {
            margin-top: 0;
          }
        }
      }
    }
    .pro_goods_menu {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: .49rem;
      background: #fff;
      z-index: 99;
      .iconbtn {
        float: left;
        /*width: 32%;*/
        padding-top: .09rem;
        .kefu {
          float: left;
          margin-left: .28rem;
          img {
            width: .22rem;
            height: .22rem;
            margin: 0 auto;
          }
          .txt {
            font-size: .12rem;
            text-align: center;
            transform: scale(0.75);
            -webkit-transform: scale(0.75);
            -moz-transform: scale(0.75);
            -ms-transform: scale(0.75);
            -o-transform: scale(0.75);
            color: #222222;
          }
        }
        .cart {
          float: left;
          margin-left: .28rem;
          img {
            width: .22rem;
            height: .22rem;
            margin: 0 auto;
          }
          .txt {
            font-size: .12rem;
            text-align: center;
            transform: scale(0.75);
            -webkit-transform: scale(0.75);
            -moz-transform: scale(0.75);
            -ms-transform: scale(0.75);
            -o-transform: scale(0.75);
            color: #222222;
          }
        }
      }
      .button {
        float: right;
        width: 29%;
        color: #fff;
        font-size: .16rem;
        line-height: .38rem;
        text-align: center;
        border-radius:0.19rem;
      }
      .shopcart {
        background: #222222;
        margin-top:0.06rem;
        background:linear-gradient(90deg,rgba(255,167,0,1) 0%,rgba(255,186,0,1) 100%);
        background:-webkit-linear-gradient(90deg,rgba(255,167,0,1) 0%,rgba(255,186,0,1) 100%);
        background:-moz-linear-gradient(90deg,rgba(255,167,0,1) 0%,rgba(255,186,0,1) 100%);
        background:-ms-linear-gradient(90deg,rgba(255,167,0,1) 0%,rgba(255,186,0,1) 100%);
        background:-o-linear-gradient(90deg,rgba(255,167,0,1) 0%,rgba(255,186,0,1) 100%);
      }
      .buy {
        margin-left: 0.08rem;
        margin-right: 0.11rem;
        margin-top:0.06rem;
        background: linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
        background:-webkit-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
        background:-moz-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
        background:-ms-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
        background:-o-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(255,20,79,1) 100%);
      }
    }
    .marquee {
      position: fixed;
      left: 0.1rem;
      top: 0.5rem;
      z-index: 1;
      width: 62%;
      height: 0.3rem;
      background: #FC0324;
      opacity: .6;
      border-radius: 0.15rem;
      padding: 0.01rem;
      .marqueeitem {
        font-size: 0.13rem;
        color: #ffffff;
        line-height: 0.28rem;
        img {
          width: 0.28rem;
          height: 0.28rem;
          float: left;
          border-radius: 0.14rem;
          margin-right: 0.1rem;
        }
      }
    }
    .sure1 {
      background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    }
    .sureGray {
      opacity: 0.38;
    }
    .sure {
      background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
      height: .43rem;
      border-radius:.25rem;
      line-height: .22rem;
      font-size: .16rem;
    }
    .parsetime{
      color:#FFCACA;
      font-size: .1rem;
      line-height: .14rem;
      transform: scale(0.85);
    }
    .fade-enter-active, .fade-leave-active {
      transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
    .van-action_model {
      height: 70vh;
      .van-item {
        padding: .14rem;
        .tit {
          font-size: .14rem;
          color: #262626;
          font-weight:400;
          line-height: .23rem;
        }
        .con {
          padding-top: .1rem;
          line-height: .23rem;
          font-size: .14rem;
          color: #333333;
        }
      }
      .btn{
        padding: .14rem;
        width: 100%;
        position: fixed;
        bottom: 0;
        left:0;
        .vanbtn{
          width: 100%;
          height: .43rem;
          background:linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%);
          border-radius:.25rem;
        }
      }
    }
    .van-action-sheet__close{
      background: url("../../assets/images/closex.png") center no-repeat;
      background-size: .2rem .2rem;
    }
    .presale_info_dialog {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.5);
      .dialog {
        width: 79%;
        margin: 0 auto;
        background: #fff;
        border-radius: .04rem;
        height: 2.24rem;
        position: relative;
        .header {
          width: 70%;
          margin: 0 auto;
          font-weight: bold;
          .van-divider {
            display: -webkit-box;
            display: -webkit-flex;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            align-items: center;
            margin: .2rem 0;
            line-height: .24rem;
            border-color: #666666;
            border-style: solid;
            border-width: 0;
            color: #333333;
            font-size: .21rem;
          }
          .van-divider::before, .van-divider::after {
            content: ' ';
            display: block;
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            flex: 1;
            box-sizing: border-box;
            height: 1px;
            border-color: inherit;
            border-style: inherit;
            border-width: 0 0 0;
            margin-right: .16rem;
            margin-left: .16rem;
          }
        }
        .content {
          width: 80%;
          margin: 0 auto;
          text-align: center;
          color: #444444;
          font-size: .14rem;
          margin-top: .02rem;
          line-height: .2rem;
          height: 1.2rem;
          overflow-y: auto;
        }
        .btn {
          background: #FC0324;
          width: 50%;
          text-align: center;
          color: #fff;
          font-size: .15rem;
          border-radius: .16rem;
          height: .31rem;
          line-height: .31rem;
          position: absolute;
          left: 25%;
          bottom: .22rem;
        }
      }
    }
    .homeBtn {
      z-index: 10;
      position: fixed;
      right:0.17rem;
      bottom:0.8rem;
      width:0.4rem;
      height:0.4rem;
      border-radius: 50%;
      background:rgba(255,255,255,1);
      box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      -webkit-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      -moz-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      -ms-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      -o-box-shadow:0 0.01rem 0.05rem 0 rgba(159,159,159,0.5);
      display: flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -webkit-flex;
      display: -o-flex;
      flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -webkit-flex-direction: column;
      -o-flex-direction: column;
      justify-content: center;
      -moz-justify-content: center;
      -ms-justify-content: center;
      -webkit-justify-content: center;
      -o-justify-content: center;
      align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -webkit-align-items: center;
      -o-align-items: center;
      img {
        width: 0.4rem;
        height: 0.4rem;
        display: block;
      }
    }
    #img {
      position: relative;
      #posterlogoewm {
        content: '';
        display: block;
        width: 0.2rem;
        height: 0.2rem;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
      }
    }
    }
</style>
<style lang="scss">
  .container {
    .pro_details_con {
      font-size: .14rem;
    }
    .pro_details_con img {
      width: 100% !important;
      height: auto !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/productList/productDetail.vue